import ProgressTracker from "../ProgressTracker";
import { Header } from "./utils/desktop/components";
import styled from "@emotion/styled";
import AttorneyServicesComponent from "../AttorneyServicesComponent";

const StyledHeader = styled(Header)`
  background-color: transparent;
  box-shadow: none;
  justify-content: space-between;
  gap: 32px;
`;

const ProgressTrackerContainer = styled.div<{ fullWidth?: boolean }>`
  flex: 1;
  display: flex;
  ${({ fullWidth }) =>
    fullWidth &&
    `
    width: 100%;
    justify-content: center;
  `}
`;

interface UserHeaderProps {
  hideAttorneyServices?: boolean;
}

const UserHeader = ({ hideAttorneyServices = false }: UserHeaderProps) => {
  return (
    <StyledHeader>
      <ProgressTrackerContainer fullWidth={hideAttorneyServices}>
        <ProgressTracker />
      </ProgressTrackerContainer>
      {!hideAttorneyServices && <AttorneyServicesComponent />}
    </StyledHeader>
  );
};

export default UserHeader;
